import { TaskServiceInterface } from 'domain/services';
import {
  TaskListUseCaseInterface,
  TaskCreateUseCaseInterface,
  TaskDeleteUseCaseInterface,
  TaskUpdateUseCaseInterface,
  TaskGetByIdUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  taskList: TaskListUseCaseInterface;
  taskCreate: TaskCreateUseCaseInterface;
  taskUpdate: TaskUpdateUseCaseInterface;
  taskDelete: TaskDeleteUseCaseInterface;
  taskGetById: TaskGetByIdUseCaseInterface;
}

export class TaskService implements TaskServiceInterface {
  private readonly _taskList: TaskListUseCaseInterface;
  private readonly _taskCreate: TaskCreateUseCaseInterface;
  private readonly _taskUpdate: TaskUpdateUseCaseInterface;
  private readonly _taskDelete: TaskDeleteUseCaseInterface;
  private readonly _taskGetById: TaskGetByIdUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._taskList = usecases.taskList;
    this._taskCreate = usecases.taskCreate;
    this._taskUpdate = usecases.taskUpdate;
    this._taskDelete = usecases.taskDelete;
    this._taskGetById = usecases.taskGetById;
  }

  taskList(
    params: TaskListUseCaseInterface.Params,
  ): Promise<TaskListUseCaseInterface.Result> {
    return this._taskList.execute(params);
  }

  taskCreate(
    params: TaskCreateUseCaseInterface.Params,
  ): Promise<TaskCreateUseCaseInterface.Result> {
    return this._taskCreate.execute(params);
  }

  taskUpdate(
    params: TaskUpdateUseCaseInterface.Params,
  ): Promise<TaskUpdateUseCaseInterface.Result> {
    return this._taskUpdate.execute(params);
  }

  taskGetById(
    params: TaskGetByIdUseCaseInterface.Params,
  ): Promise<TaskGetByIdUseCaseInterface.Result> {
    return this._taskGetById.execute(params);
  }

  taskDelete(
    params: TaskDeleteUseCaseInterface.Params,
  ): Promise<TaskDeleteUseCaseInterface.Result> {
    return this._taskDelete.execute(params);
  }
}
